import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Paper from "@material-ui/core/Paper/Paper";
import ScheduleForm from "../../components/Schedules/ScheduleForm";
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import CardContent from "@material-ui/core/CardContent/CardContent";

const SchedulesCreate = ({classes, course, formUrl, preselectedHouse, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('schedules.new_subject')}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('schedules.back'),
                    href: redirectAfterSubmit,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(redirectAfterSubmit);
                    },
                }
            ]}
        />

        <Paper>
            <CardContent>
                <ScheduleForm
                    course={course}
                    formUrl={formUrl}
                    isEdit={false}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Paper>
    </Layout>
);

export default SchedulesCreate;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/schedules/Create.jsx